import React, { useState, useRef } from 'react';
import Select from "react-select";
import {
    ControlLabel,
    FormControl,
    FormGroup,
    Button,
    Glyphicon,
} from "react-bootstrap";

const timeoutOptions = [0, 1, 3, 5, 10, 15, 20, 30, 60].map(value => ({ value, label: value === 0 ? 'До закрытия' : `${value} секунд${value === 1 ? 'у' : value === 3 ? 'ы' : ''}` }));

export default ({ notification, onEditProperty, onSave }) => {

    const imageInputRef = useRef(null);

    const [photoUrl, setPhotoUrl] = useState(notification?.banner || '');

    const handlePhoto = () => {
        const file = imageInputRef.current?.files[0];
        setPhotoUrl(file ? URL.createObjectURL(file) : null);
    }

    if (!notification) return null;

    return <div>
        <FormGroup>
            <ControlLabel>Название</ControlLabel>
            <FormControl
                type="text"
                value={notification.name || ""}
                onChange={(e) => onEditProperty('name', e.target.value)}
            />
        </FormGroup>
        <FormGroup>
            <ControlLabel>Отображать</ControlLabel>
            <Select
                value={timeoutOptions.find(({ value }) => notification.time === value) || timeoutOptions[0]}
                onChange={({ value }) => onEditProperty('time', value)}
                options={timeoutOptions}
            />
        </FormGroup>
        <FormGroup>
            <ControlLabel>Ссылка</ControlLabel>
            <FormControl
                type="text"
                value={notification.link || ""}
                onChange={(e) => onEditProperty('link', e.target.value)}
            />
        </FormGroup>
        <FormGroup>
            <ControlLabel>Заголовок</ControlLabel>
            <FormControl
                type="text"
                value={notification.header || ""}
                onChange={(e) => onEditProperty('header', e.target.value)}
            />
        </FormGroup>
        <FormGroup>
            <ControlLabel>Сообщение</ControlLabel>
            <FormControl
                componentClass="textarea"
                rows={4}
                value={notification.text || ""}
                onChange={(e) => onEditProperty('text', e.target.value)}
            />
        </FormGroup>
        <FormGroup>
            <ControlLabel>Фон</ControlLabel>
            <div>
                <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
            </div>
            <FormControl
                type="file"
                onChange={handlePhoto}
                inputRef={ref => imageInputRef.current = ref}
                style={{ display: 'none' }}
            />
            {photoUrl && <img alt="" src={photoUrl} style={{width: '100%', maxHeight: 140, objectFit: 'cover'}}/>}
        </FormGroup>
        <Button style={{ width: '100%', marginTop: '1rem' }} bsStyle="success" onClick={() => onSave(imageInputRef.current?.files[0] || null)}>Сохранить</Button>
    </div>
}